import { render, staticRenderFns } from "./JobDetailsView.vue?vue&type=template&id=0d68c446&scoped=true"
import script from "./JobDetailsView.vue?vue&type=script&lang=js"
export * from "./JobDetailsView.vue?vue&type=script&lang=js"
import style0 from "./JobDetailsView.vue?vue&type=style&index=0&id=0d68c446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d68c446",
  null
  
)

export default component.exports